import React, { useEffect } from 'react';
import { ComposableDeviceFormProps } from '../../../../components/ComposableDevice/ComposableDeviceForm/ComposableDeviceForm';
import { getPolyglot } from '../../../../i18n';
import { Stack, Typography } from '@mui/material';
import { DeviceForm } from './ComposableDeviceForm/DeviceForm';
import { ImageForm } from './ComposableDeviceForm/ImageForm';
import { DecksForm } from './ComposableDeviceForm/DecksForm';
import * as yup from 'yup';

export const ComposableDeviceForm = (
  props: ComposableDeviceFormProps & { closeAddComposableDevice?: () => void }
) => {
  const {
    setValidationSchema,
    validationSchema,
    formik,
    image,
    logo,
    setImage,
    setLogo,
    closeAddComposableDevice,
  } = props;
  const polyglot = getPolyglot();
  const isEditMode = Boolean(formik.values?.id);

  useEffect(() => {
    if (setValidationSchema) {
      const devicesValidationSchema = yup.object({
        devices: yup
          .array()
          .of(yup.string())
          .min(1, polyglot.t('composable_device.devices_required'))
          .required(polyglot.t('composable_device.devices_required'))
          .test(
            'devices-equality',
            polyglot.t('fours_fringand.oven.devices_must_be_unique'),
            function (items) {
              const filteredItems = items.filter(
                (item) => item && item?.trim()?.length > 0
              );
              return new Set(filteredItems).size === filteredItems.length;
            }
          )
          .test('model-deck-quantity', function (items, context) {
            const commandersQuantity = Number(
              context.parent.composableDevice?.labels?.commandersQuantity
            );
            if (
              !isNaN(commandersQuantity) &&
              items.filter((item) => item && item?.trim()?.length > 0)
                ?.length !== Number(commandersQuantity)
            )
              return this.createError({
                message: polyglot.t(
                  'fours_fringand.oven.devices_quantity_must_equal'
                ),
              });

            return true;
          }),
      });

      setValidationSchema(validationSchema.concat(devicesValidationSchema));
    }
  }, []);
  return (
    <>
      {!isEditMode ? (
        <Typography variant="body2" textAlign={'start'}>
          {polyglot.t('composable_device.add_composable_device_information')}
        </Typography>
      ) : null}
      <form onSubmit={formik.handleSubmit}>
        <Stack
          display="grid"
          gridTemplateColumns={isEditMode ? '1fr' : '1fr 1fr 1fr'}
          gap={1}
          marginTop={2}
        >
          <DeviceForm formik={formik} />
          <DecksForm formik={formik} />
          <ImageForm
            formik={formik}
            setImage={setImage}
            setLogo={setLogo}
            image={image}
            logo={logo}
            closeAddComposableDevice={closeAddComposableDevice}
          />
        </Stack>
      </form>
    </>
  );
};
